// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UFzG","image":"Header_image__2WMkm","name":"Header_name__qjyfT","info":"Header_info__2qG55","infoRow":"Header_infoRow__1o1Gy"};